import headerActionButtons from "./actionButtonTypes/headerActionButtons";
import footerActionButtons from "./actionButtonTypes/footerActionButtons";
import bvModalActionButtons from "./actionButtonTypes/bvModalActionButtons";
import bvRatingSummaryActionButtons from "./actionButtonTypes/bvRatingSummaryActionButtons";
import psWidgetActionButtons from "./actionButtonTypes/psWidgetActionButtons";
import { setBvModalObserver } from "../bv/setBvModalObserver";
import bvReviewsActionButton from "./actionButtonTypes/bvReviewsActionButton";
import productInfoModalActionButton from "./actionButtonTypes/productInfoModalActionButton";

/**
 * Listen to all action button clicks on the site and decide if we should pass into GTM
 */

// const getActionButtonTarget = target => target.hasAttribute("data-gtm-click") ? target : target.closest("[data-gtm-click]");

const getActionButtonTarget = (target) => {
  const isButton = target.localName === "button" || target.closest("button");
  const isPsWidgetButton = target.dataset.retailer || target.closest("[data-retailer]");
  const isBvModalWidgetButton = target.closest("#bv_components_histogram");
  const isReviewsButton = target.closest(".reviews");
  const isProductInfoModal = target.closest(".product-info-gtm");
  const isInsideWidget = target.closest("[data-bv-modal], [data-bv-show='rating_summary'], #ps-widget, .reviews");

  if (isInsideWidget) {
    if (isButton) {
      return target.localName === "button"
        ? target
        : target.closest("button");
    }

    if (isBvModalWidgetButton) {
      return target.localName === "button"
        ? target
        : target.closest("[role='menuitem']");
    }

    if (isPsWidgetButton) {
      return target.dataset.retailer
        ? target
        : target.closest("[data-retailer]");
    }

    if (isReviewsButton || isProductInfoModal) return target;
  }

  return target.hasAttribute("data-gtm-click")
    ? target
    : target.closest("[data-gtm-click]");
};


/**
 * This is a list of modules to test what kind of link this is and what event 
 * should be sent to GTM based on the dataLayer rules
 * These are performed in the order they are shown in the list and will only fire
 * a single event.
 * 
 * Each module exports an object with the following shape
 * 
 * {
 *   test: function(){}, Takes the ops object and tests the link or target of the click event to evaluate if this should trigger the GTM event. Return Boolean
 *   push: function(){}, Does the actual work of calling trackEvent() and creating the object shape to push
 *   name: String used to debug :) 
 * }
 */
const actionButtonTestTypes = [headerActionButtons, footerActionButtons, psWidgetActionButtons, bvModalActionButtons, bvRatingSummaryActionButtons, bvReviewsActionButton, productInfoModalActionButton];

const trackLink = (ops) => {
  for (i = 0; i < actionButtonTestTypes.length; i++) {
    const test = actionButtonTestTypes[i].test;

    if (test(ops)) {
      const push = actionButtonTestTypes[i].push;
      push(ops);
      break;
    }
  }
};

/**
 * Capture all clicks on the body and ensure the clicked item
 * has the href value with a value
 */
document.body.addEventListener("click", (e) => {
    const target = getActionButtonTarget(e.target);

    if (target && target.localName !== "a") {
        // The `target` here should be the HTML element.
        trackLink({ target, e });
    }

    setBvModalObserver();
}, true);